import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import OutsideClickHandler from 'react-outside-click-handler';
import { Block, Tag, Label, Icon, Circle } from '../..';
import DateHelpers from '../../../../core/helpers/DateHelper';
import CardHelpers from '../../../../core/helpers/CardHelper';
import iconMappin from '../../../../assets/icons/icon-map-pin.svg';
import iconAmbiente from '../../../../assets/icons/icon-ambiente.svg';
import iconPiso from '../../../../assets/icons/icon-piso.svg';
import iconTipoClase from '../../../../assets/icons/icon-tipo-clase.svg';
import iconLaptopImage from '../../../../assets/icons/icon-laptop-bg-black.svg';
import iconRemoto from '../../../../assets/icons/icon-remoto.svg';
import iconZoom from '../../../../assets/icons/icon-zoom.svg';
import iconReprog from '../../../../assets/icons/icon-reprogramCourse.svg';
import zoom from '../../../../assets/icons/zoom.svg';
import constants from '../../../../core/constants';
import TextHelper from '../../../../core/helpers/TextHelper';
import Tooltip from '../../Tooltip/Tooltip';
import CardDetail from './CardDetail';
import { CourseSummary } from './courseDetail.style';
import ReusableButton from '@/presentation/reusables/Button';
import ButtonAnnul from '@/presentation/modules/events/components/ButtonAnnul';
import BottonZoom from './ButtonZoom';
import ZoomBindingPrompt from './ZoomBindingPrompt';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const WrapCourseDetail = styled.article`
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0px;
  background-color: #fff;
  z-index: 2;
  border-radius: 0px;
  padding-left: 0px;
  padding-right: 0px;
  overflow: auto;
  // display: flex;
  // padding: 32px;
  img.icon {
    width: 12px;
    height: 12px;
  }

  .header {
    justify-content: space-between;
    width: 100%;
    display: flex;
  }

  .headerLabel {
    padding-top: 0px;
  }

  .header > * {
    display: flex;
    align-items: center;
  }

  .title {
    margin-bottom: 12px;
    margin-top: 15px;
    justify-content: flex-start;
    align-self: auto;
    position: relative;
    width: 95%;
    display: flex;
    align-items: baseline;
  }

  .title > * {
    display: inline-flex;
    //max-width: 218px;
  }

  .title > u {
    /* position: absolute;
    top: 8px; */
  }

  .title > label {
    /* padding-left: 15px; */
    font-weight: 900;
  }

  .noZoomRow {
    display: flex;
    margin-top: 16px;
    margin-bottom: 8px;
    padding-left: 0px;
    align-items: center;
    width: 100%;
  }

  .noZoomRow label {
    color: #1a055d;
    margin-left: 5.33px;
    line-height: 20px;
    font-weight: 700;
  }

  .completeRow {
    display: flex;
    margin-top: 4px;
    padding-left: 0px;
    // max-width: 218px;
    align-items: center;
    width: 100%;
  }

  .row {
    display: flex;
    margin-top: 4px;
    padding-left: 0px;
    // max-width: 218px;
    align-items: center;
    width: 95%;
    // margin-left: 15px;
  }

  .row label {
    font-weight: normal;
  }
  label.professor {
    font-size: 14px;
    line-height: 20px;
  }

  .professorName {
    font-weight: 900;
  }

  label.professorNameBold {
    font-weight: 700;
  }

  .row:first-child {
    padding-left: 0px;
  }

  .row.center {
    justify-content: center;
  }

  .row.top {
    align-items: start;
    padding-left: 16px;
  }

  .row.top cc-icon {
    margin-top: 4px;
  }

  .icon {
    color: var(--interaction-detail);
    align-items: start;
    cursor: pointer;
    height: 56px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 16px;
    border-bottom: 1px solid #7a959f;
  }

  .icon > cc-icon {
    border-width: 1px;
    padding: 8px;
  }

  .shadowInset {
    box-shadow: inset 0 8px 16px -14px rgb(0 0 0 / 0.4);
  }

  .paragraph {
    // font-family: 'Lato';
    font-size: 14px;
    line-height: 20px;
    margin-left: 8px;
    font-weight: normal;
    color: var(--text-text02);
  }

  .paragraph label {
    font-weight: 900;
  }

  .message1 {
    // font-family: 'Lato';
    font-size: 11px;
    margin-left: 0px;
    font-weight: normal;
    color: var(--text-text02);
    line-height: normal;
  }

  .review {
    // font-family: 'Lato';
    font-size: 12px;
    margin-left: 0px;
    font-weight: normal;
    color: var(--text-text02);
  }

  .buttonRemote {
    border: 1px solid #5b36f2;
    border-radius: 4px;
    padding: 12px 16px;
    /*cursor: pointer;*/
    margin-top: 12px;
    background: #5b36f2;
    width: 100%;
  }
  .buttonRemote.disabled {
    pointer-events: none; /* Evita clics */
    opacity: 0.5; /* Apariencia deshabilitada */
    cursor: not-allowed; /* Cursor no permitido */
  }

  .buttonRemote:hover {
    background-color: #745ef6;
    outline: 0;
  }

  .buttonRemote:focus {
    background-color: #4318cd;
    outline: 0;
  }

  .buttonRemote:active {
    background-color: #4318cd;
    outline: 0;
  }

  .buttonRemote .label {
    font-size: 12px;
    font-weight: 900;
    display: flex;
    justify-content: center;
    line-height: 24px;
  }
  .buttonRemote .label.zoom {
    color: #ffffff;
    margin: 0px 70px;
  }

  .buttonRemote .label.zoom img {
    margin-right: 4px;
  }

  .button {
    border: 1px solid var(--interaction-secondary);
    border-radius: 4px;
    padding: 12px 16px;
    /*cursor: pointer;*/
    margin-top: 16px;
    margin-left: 16px;
  }

  .button .label {
    color: var(--text-text02);
    font-size: 12px;
    font-weight: 900;
    display: flex;
    justify-content: space-between;
    line-height: 24px;
  }
  .button .label.zoom {
    color: var(--text-secondary);
  }

  .button .label img {
    margin-right: 4px;
  }

  .titleFontSize {
    font-size: 16px;
    line-height: 24px;
  }
  .dateFontSize {
    font-size: 14px;
    line-height: 20px;
  }
  .timeFontSize {
    font-size: 14px;
    line-height: 20px;
    margin-right: 21px;
  }
  .disclaimer {
    font-size: 14px;
    line-height: 20px;
    padding-left: 16px;
  }

  .circle-blended {
    display: inline-flex;
    height: 6px;
    width: 6px;
    margin-left: 3px;
    background: #a4305e;
  }
  .label-blended {
    margin-left: 0px;
    color: #b21f5f;
  }

  label.virtualCourseDetail {
    font-size: 14px;
    font-weight: 700;
  }

  label.remoteCourseDetail {
    font-size: 14px;
  }

  @media (min-width: 360px) {
    >div: last-child {
      padding-bottom: 50px !important;
      padding-top: 20px !important;
    }
  }

  @media (min-width: 640px) {
    height: auto;
    overflow: hidden;
    position: absolute;
    // border-radius: 8px;
    box-shadow: 0 8px 32px -16px var(--neutral-03);
    width: 360px;
    padding: 0px 16px 0px 16px;
    padding-left: 0px;
    padding-right: 0px;

    .headerLabel {
      padding-top: 0px;
    }

    .title {
      margin-top: 16px;
      margin-bottom: 8px;
    }

    .title > label {
      font-size: 16px;
      line-height: 24px;
    }

    .row {
      // padding-left: 10px;
      margin-left: 0px;
    }
    .titleFontSize {
      font-size: 16px;
      line-height: 20px;
    }
    .dateFontSize {
      font-size: 14px;
      line-height: 20px;
    }
    .timeFontSize {
      font-size: 14px;
      line-height: 20px;
    }
    label.professor {
      font-size: 14px;
      line-height: 20px;
    }
    .disclaimer {
      font-size: 12px;
      line-height: 16px;
    }
    .paragraph {
      font-size: 12px;
      line-height: 16px;
    }
  }
  @media (min-width: 768px) {
    height: auto;
    overflow: hidden;
    position: absolute;
    // border-radius: 8px;
    box-shadow: 0 8px 32px -16px var(--neutral-03);
    width: 360px;
    padding: 0px 16px 0px 16px;
    padding-left: 0px;
    padding-right: 0px;

    .headerLabel {
      padding-top: 0px;
    }

    .title {
      margin-top: 16px;
      margin-bottom: 8px;
    }

    .title > label {
      font-size: 16px;
      line-height: 24px;
    }

    .row {
      // padding-left: 10px;
      margin-left: 0px;
    }
    .titleFontSize {
      font-size: 16px;
      line-height: 20px;
    }
    .dateFontSize {
      font-size: 14px;
      line-height: 20px;
    }
    .timeFontSize {
      font-size: 14px;
      line-height: 20px;
    }
    label.professor {
      font-size: 14px;
      line-height: 20px;
    }
    .disclaimer {
      font-size: 12px;
      line-height: 16px;
    }
    .paragraph {
      font-size: 12px;
      line-height: 16px;
    }
  }
  .tech-link-detail {
    margin-top: 8px;
    margin-left: 16px;
    margin-right: 16px;
    margin-bottom: 24px;
    font-size: 12px;
  }
`;

export const SeparatorLine = styled.div.attrs((props) => ({
  color: props.color
}))`
  height: 1px;
  background-color: ${(props) => props.color};
  width: 100%;
`;

export const ContainerDetail = styled.div`
  margin: 24px 10px 2px 16px;
  padding: 12px;
  border-width: 1px;
  border-color: #a8cbe2;
  background-color: #f7fafb;
  border-radius: 8px;

  ul {
    list-style: unset;
    margin-left: 24px;
    text-align: start;
  }

  ul li {
    margin-top: 0px;
  }

  b {
    font-weight: 700;
  }
`;

export const HowToGet = styled.div`
  display: flex;
  min-width: 116px;
  justify-content: center;
  margin-left: 12px;
`;

const HowToGetVirtual = styled.div`
  display: flex;
  // min-width: 75px;
  gap: 4px;
  align-items: center;
  margin-left: 14px;
  margin-right: 4px;
`;
interface HowToGetRemotoProps {
  isHybrid?: boolean;
}

const HowToGetRemoto = styled.div<HowToGetRemotoProps>`
  display: flex;
  min-width: ${(props) => (props.isHybrid ? '130px' : '80px')};
  justify-content: center;
  img {
    margin: 0px 4px 0px 0px;
  }
`;

export const WrapperHowToGet = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
`;

const WrapperGoToButton = styled.button.attrs((props: any) => ({
  padding: props.padding,
  buttonType: props.buttonType
}))`
  display: inline-flex;
  align-items: center;
  padding: ${(props) => props.padding};
  border-radius: 4px;
  -webkit-transition: background 400ms ease-in-out;
  transition: background 400ms ease-in-out;
  > Label {
    font-size: 14px;
    font-weight: 700;
    color: var(--button-${(props) => props.buttonType}-main);
  }
  > cc-icon {
    color: var(--button-${(props) => props.buttonType}-main);
  }
  :hover {
    -webkit-transition: background 400ms ease-in-out;
    transition: background 400ms ease-in-out;
    background-color: var(--button-${(props) => props.buttonType}-hover);
  }
  :focus {
    -webkit-transition: background 400ms ease-in-out;
    transition: background 400ms ease-in-out;
    background: var(--button-${(props) => props.buttonType}-focus);
    outline: 0;
  }
  :active {
    -webkit-transition: background 0ms ease-in-out;
    transition: background 0ms ease-in-out;
    background-color: var(--button-${(props) => props.buttonType}-focus);
  }
`;

const circleColor = '#b21f5f';

const ContainerBtnRedirect = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 16px 0px 16px;
  width: 100%;

  .title__redirect {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    align-self: start;
    margin-bottom: 8px;
  }

  .btn__redirect {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #5b36f2;
    border: 1px solid #5b36f2;
    border-radius: 4px;
    padding: 10px 16px;
    width: 100%;
    &:hover {
      background: #e2dffd;
    }

    &:focus {
      background: #c6c0fc;
    }

    &:active {
      background: #c6c0fc;
    }
  }
`;

export const GoToButton = ({ padding, onClick, children, buttonType }: any) => (
  <WrapperGoToButton
    data-testid="btn-go-to-buttom-detail"
    onClick={onClick}
    padding={padding}
    buttonType={buttonType}
  >
    {children}
  </WrapperGoToButton>
);
export const DetailRow = ({
  icon,
  labelText,
  valueText,
  colorTextValue,
  children
}: any) => (
  <Block
    flex
    style={{
      justifyContent: 'space-between'
    }}
  >
    <Block
      flex
      style={{ alignItems: 'center', paddingTop: 10, paddingBottom: 10 }}
    >
      <img src={icon} alt="" style={{ height: 16, marginRight: 8 }} />
      <Label size={14} color="var(--text-text01)" text={labelText} />
      &nbsp;
      <Label
        size={14}
        color={colorTextValue ?? 'var(--text-text01)'}
        text={valueText}
      />
    </Block>
    <Block>{children}</Block>
  </Block>
);

function useScrollTop() {
  const [scrollTop, setScrollTop] = React.useState(0);
  const onScroll = (event: any) => setScrollTop(event.target.scrollTop);
  return [scrollTop, { onScroll }];
}

const CourseDetail = (props: any) => {
  const {
    contentData,
    cardType,
    onClose,
    dateEvent,
    index,
    isClass,
    isReprogramming
  } = props;
  const [scrollTop, scrollProps] = useScrollTop();
  const { onScroll }: any = scrollProps;
  const [showTooltip, setShowTooltip] = React.useState(false);
  const closeToolTip = () => {
    setShowTooltip(false);
  };
  const openToolTip = (e: any) => {
    e.target.parentElement.blur();
    e.target.blur();
    setShowTooltip(true);
  };

  const openMap = (event: any) => {
    const e = event;
    e.target.parentElement.blur();
    e.target.blur();
    document.open(
      `${constants.URL_MAPS}${contentData?.location?.building?.coordinates?.latitude},${contentData?.location?.building?.coordinates?.longitude}`,
      '',
      'noopener=true'
    );
  };
  const content = CardHelpers.getCardProcessed(
    cardType,
    contentData,
    dateEvent
  );

  const content2 = CourseSummary(cardType, contentData, dateEvent);
  const campusDesc = useSelector(
    (state: any) => state.profile?.data?.academic?.campusDesc
  );

  const isCGT = useSelector(
    (state: any) => state.profile?.data?.academic?.isCGT
  );

  const goToClass = () => (
    <div style={{ margin: '32px 10px 0px 16px' }}>
      <p
        style={{
          fontWeight: 'bold',
          color: '#161D1F'
        }}
      >
        Revisa el contenido del curso y las grabaciones de tus clases en vivo:
        <ReusableButton
          outlined
          style={{ marginTop: '16px', width: '100%' }}
          text="Ir a UTP+class"
          onClick={(e: any) => {
            GoogleAnalytics.writeLog('portal-schedule-goClass', 'schedule');
            e.target.blur();
            e.target.parentElement.blur();
            window.open(contentData.linkCourseClass, 'UTP+class', 'noopener');
          }}
        />
      </p>
    </div>
  );

  return (
    <>
      <WrapCourseDetail
        data-testid="cmp-course-detail"
        className={CardHelpers.getCardDetailPosition(
          cardType === 'V' ? index : -1,
          cardType,
          cardType === 'V' ? 0 : DateHelpers.getThisDayNumber(dateEvent?.date)
        )}
      >
        <Block className="icon">
          <GoToButton padding="10px" buttonType="close" onClick={onClose}>
            <Icon name="x" size={22} />
          </GoToButton>
        </Block>
        <div
          onScroll={onScroll}
          className="scroll1"
          style={{
            height:
              (cardType === constants.CARD_TYPES.CURSO_PRESENCIAL ||
                constants.CARD_TYPES.CURSO_VIRTUAL === cardType ||
                constants.CARD_TYPES.CURSO_REMOTO === cardType) &&
              !isMobile
                ? '100%'
                : 'auto',
            boxShadow:
              (scrollTop as number) > 0
                ? 'inset 0px 4px 16px -13px #748E98'
                : 'none'
          }}
        >
          {cardType !== 'E' && (
            <Block style={{ paddingLeft: 16, paddingRight: 16 }}>
              <Block className="header" style={{ margin: 0, padding: 0 }}>
                <Block flex className="headerLabel">
                  <Tag
                    backgroundColor={content2?.tag?.background}
                    color={content2?.tag?.color}
                    padding="4px 12px 4px 12px"
                    margin="0px 0px 0px 0px"
                    radius={20}
                    lineHeight={16}
                    size={12}
                    height={24}
                    bold
                  >
                    {content2?.tag?.label2}
                  </Tag>
                  {isReprogramming && (
                    <>
                      <div style={{ margin: '0px 6px 0px 10px' }}>
                        <img alt="" src={iconReprog} />
                      </div>
                      <Label
                        size={14}
                        text={'Reprogramado'}
                        black
                        color={'#0071BF'}
                      />
                    </>
                  )}
                </Block>
              </Block>
              <Block className="title">
                <Label
                  size={isMobile ? 16 : 14}
                  black
                  text={TextHelper.fixRomans(
                    `Curso: ${content?.detail?.title}`
                  )}
                  color="var(--text-text02)"
                />
              </Block>

              <Block className="row">
                <Label
                  size={11}
                  light
                  lineHeight={15}
                  text={
                    cardType === 'V'
                      ? ` ${content2?.detail?.hour}`
                      : content2?.detail?.hour || ''
                  }
                  color="var(--text-text02)"
                  className="timeFontSize"
                />
                {isCGT && contentData.instructionMode === 'SP' ? ( // COMENTADO TEMPORALMENTE
                  <>
                    <Circle color={circleColor} className="circle-blended" />
                    <Label
                      size={14}
                      light
                      lineHeight={20}
                      text="Semipresencial"
                      color="var(--text-text02)"
                      className="timeFontSize label-blended"
                    />
                  </>
                ) : (
                  <></>
                )}
              </Block>
              {cardType !== 'E' && (
                <Block className="row">
                  {/* <Icon name="user" size={12} /> */}
                  <p className="message1">
                    <Label
                      className="professor"
                      text={cardType === 'R' ? 'Tutor' : 'Docente:'}
                    />
                    <Label
                      className="professor professorNameBold"
                      text={
                        TextHelper.capitalize(
                          content2?.detail?.teacher || ''
                        ) || 'No asignado'
                      }
                      marginLeft={3}
                    />
                  </p>
                </Block>
              )}
            </Block>
          )}

          {cardType === 'E' && <CardDetail contentData={contentData} />}

          {cardType === constants.CARD_TYPES.CURSO_PRESENCIAL && (
            <>
              <WrapperHowToGet>
                <HowToGet>
                  <img alt="" src={iconMappin} />
                  <div>¿Cómo llegar?</div>
                </HowToGet>
                <SeparatorLine color="#D5E5F0" />
              </WrapperHowToGet>
              <ContainerDetail>
                <DetailRow
                  icon={iconAmbiente}
                  labelText="Ambiente:"
                  valueText={
                    contentData?.location?.classRoom?.id || 'No asignado'
                  }
                >
                  <OutsideClickHandler onOutsideClick={closeToolTip}>
                    <Tooltip
                      isTop={(scrollTop as number) < 100}
                      visible={showTooltip}
                      onClose={closeToolTip}
                    >
                      <GoToButton
                        buttonType="secondary"
                        padding="10px"
                        onClick={openToolTip}
                      >
                        <Icon name="info" size={20} />
                      </GoToButton>
                    </Tooltip>
                  </OutsideClickHandler>
                </DetailRow>
                <SeparatorLine color="#BFD8E9" />
                <DetailRow
                  icon={iconTipoClase}
                  labelText="Tipo:"
                  valueText={content?.classTypeText || ''}
                />
                <SeparatorLine color="#BFD8E9" />
                <DetailRow
                  icon={iconPiso}
                  labelText="Piso:"
                  valueText={
                    contentData?.location?.classRoom?.floor || 'No asignado'
                  }
                />
              </ContainerDetail>
              <ContainerDetail>
                <Block>
                  {campusDesc?.toUpperCase().includes('CAMPUS')
                    ? campusDesc
                    : `Campus ${campusDesc}`}
                </Block>
                {contentData?.location?.building && (
                  <Block style={{ marginTop: 4 }}>
                    <Label size={14} color="var(--text-text01)" text="Sede:" />
                    &nbsp;
                    <Label
                      size={14}
                      text={contentData?.location?.building?.sede}
                    />
                  </Block>
                )}
                <Block style={{ marginTop: 8, marginBottom: 16 }}>
                  {contentData?.location?.building?.address}
                </Block>
                {contentData?.location?.building &&
                  contentData?.location?.building?.coordinates?.latitude !==
                    0 && (
                    <GoToButton
                      buttonType="secondary"
                      padding="8px 16px"
                      onClick={openMap}
                    >
                      <Label text="Ver mapa" />
                      &nbsp;
                      <Icon name="arrow-right" size={24} />
                    </GoToButton>
                  )}
              </ContainerDetail>
              <ContainerDetail>
                <p
                  style={{
                    fontWeight: 'bold',
                    fontSize: '14px',
                    lineHeight: '20px',
                    paddingBottom: '20px'
                  }}
                >
                  Si no puedes asistir de manera presencial, te damos estas
                  opciones:
                </p>
                <ul style={{ listStyle: 'decimal' }}>
                  <li
                    style={{
                      fontWeight: '400',
                      fontSize: '14px',
                      lineHeight: '20px'
                    }}
                  >
                    Conéctate a tu clase que se transmite en vivo. Recuerda que
                    esta clase ha sido diseñada de manera presencial incluyendo
                    actividades e interacciones con el docente y compañeros.
                  </li>
                  <BottonZoom
                    content={content}
                    iconZoom={iconZoom}
                    cardType={cardType}
                  />
                  <p
                    style={{
                      paddingBottom: '16px',
                      paddingTop: '12px',
                      fontWeight: '400',
                      fontSize: '14px',
                      lineHeight: '20px'
                    }}
                  >
                    O ingresa a {''}
                    <span
                      style={{
                        fontWeight: 'bold',
                        fontSize: '14px',
                        lineHeight: '20px'
                      }}
                    >
                      UTP+class &lt; Mis cursos &lt; Eliges el curso &lt; Zoom
                      &lt; Unirme a Zoom
                    </span>
                  </p>
                  <li
                    style={{
                      fontWeight: '400',
                      fontSize: '14px',
                      lineHeight: '20px',
                      paddingBottom: '12px'
                    }}
                  >
                    Revisa el contenido del curso y las grabaciones de tus
                    clases en vivo en:
                  </li>
                </ul>
                <div>
                  <ButtonAnnul
                    buttonText="Ir a UTP+class"
                    onClick={(e: any) => {
                      GoogleAnalytics.writeLog(
                        'portal-schedule-goClass',
                        'schedule'
                      );
                      e.target.parentElement.blur();
                      e.target.blur();
                      window.open(
                        contentData.linkCourseClass,
                        'UTP+class',
                        'noopener'
                      );
                    }}
                    style={{ width: '-webkit-fill-available' }}
                  />
                </div>
              </ContainerDetail>
              <div style={{ padding: '22px 10px 33px 16px' }}>
                <ZoomBindingPrompt />
              </div>
            </>
          )}
          {cardType === constants.CARD_TYPES.CURSO_VIRTUAL && (
            <>
              <WrapperHowToGet>
                <HowToGetVirtual>
                  <img alt="" src={iconLaptopImage} />
                  <div>
                    {contentData?.isClass === true && 'UTP+ class'}
                    {contentData?.isClass === false && 'Canvas'}
                  </div>
                </HowToGetVirtual>
                <SeparatorLine
                  color="#D5E5F0"
                  style={{ width: isClass ? '130px' : '100%' }}
                />
              </WrapperHowToGet>
              <ContainerDetail>
                <Block>
                  <Label
                    className="virtualCourseDetail"
                    text="¿Qué es Virtual 24/7?"
                  />
                </Block>
                <ul
                  style={{
                    marginTop: 16
                  }}
                >
                  <li>
                    <p>
                      <b>Estudia tú mismo.</b> Puedes revisar tu material en
                      cualquier momento del día.
                    </p>
                  </li>
                  <li>
                    <p>
                      <b>Tareas nuevas por semana.</b>
                    </p>
                  </li>
                  <li>
                    <p>
                      <b>Acompañamiento virtual </b>
                      del docente a lo largo de todo el curso.
                    </p>
                  </li>
                </ul>
              </ContainerDetail>
            </>
          )}
          {cardType === constants.CARD_TYPES.CURSO_REMOTO && (
            <>
              <WrapperHowToGet>
                <HowToGetRemoto
                  isHybrid={contentData.isHybrid}
                  style={{ paddingLeft: '12px' }}
                >
                  <img alt="" src={iconRemoto} />

                  {contentData.isHybrid ? (
                    <div style={{ whiteSpace: 'nowrap', color: '#161D1F' }}>
                      TechLink Zoom
                    </div>
                  ) : (
                    <div>
                      {contentData?.isClass === true && 'UTP+ class'}
                      {contentData?.isClass === false && 'Zoom'}
                    </div>
                  )}
                </HowToGetRemoto>
                <SeparatorLine color="#D5E5F0" />
              </WrapperHowToGet>
              {contentData.isHybrid && (
                <div
                  className="tech-link-detail"
                  data-testid="cmp-tech-link-detail"
                  style={{ color: '#4F6168' }}
                >
                  Esta clase se desarrolla en un aula especialmente equipada
                  para incorporar a estudiantes que llevan el curso tanto
                  presencialmente como virtualmente vía Zoom.
                </div>
              )}
              <ContainerDetail>
                <Block>
                  <Label
                    className="remoteCourseDetail"
                    text="¿No puedes ingresar?"
                    bold
                    color="black"
                  />
                </Block>
                <Block className="noZoomRow">
                  <ul>
                    <li>
                      <p>
                        {contentData.isClass
                          ? 'Revisa que hayas ingresado con tu correo UTP y tu contraseña de UTP+class.'
                          : 'Revisa que hayas ingresado con tu correo UTP y tu contraseña de Canvas.'}
                      </p>
                    </li>
                    <li>
                      <p>
                        {contentData.isClass
                          ? 'En caso persista el problema, ingresa a UTP+class < Escoge tu curso < Zoom < Join'
                          : 'En caso persista el problema, ingresa a Canvas < Escoge tu curso < Zoom < Join'}
                      </p>
                    </li>
                  </ul>
                </Block>
                <BottonZoom content={content} iconZoom={iconZoom} />
              </ContainerDetail>

              {contentData?.isClass && goToClass()}
              <div style={{ padding: '16px 10px 33px 16px' }}>
                <ZoomBindingPrompt />
              </div>
            </>
          )}
          {cardType === 'R' && (
            <Block className="row">
              <p className="review disclaimer">
                Repasa los cursos en los cuales necesites un refuerzo
              </p>
            </Block>
          )}
          {(cardType === 'R' || cardType === 'A') &&
            content?.detail?.link !== '' && (
              <Block className="row">
                <a
                  className="button"
                  href={content?.detail?.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Block className="label zoom">
                    <img src={zoom} alt="icon" />
                    Unirme al Zoom
                  </Block>
                </a>
              </Block>
            )}
          {cardType !== 'E' && (
            <ContainerBtnRedirect data-testid="cmp-container-btn-redirect">
              {cardType === constants.CARD_TYPES.CURSO_REMOTO ||
              cardType === constants.CARD_TYPES.CURSO_PRESENCIAL ? null : (
                <Block>
                  <p className="title__redirect">
                    Revisa el contenido de tu clase:
                  </p>
                  <button
                    data-testid="btn-course-detail-haz-click"
                    onClick={() => {
                      GoogleAnalytics.writeLog(
                        'portal-schedule-goClass',
                        'schedule'
                      );
                      window.open(
                        contentData.linkCourseClass,
                        'UTP+class',
                        'noopener'
                      );
                    }}
                    className="btn__redirect"
                    type="button"
                    formTarget="_blank"
                  >
                    Ir a {contentData?.isClass ? 'UTP+class' : 'Canvas'}
                  </button>
                </Block>
              )}
            </ContainerBtnRedirect>
          )}
        </div>
      </WrapCourseDetail>
    </>
  );
};

export default CourseDetail;
